import convertList from '../../convertList';

export default {
    getNormalSearchData(method, params, maps) {
        return new Promise((resolve, reject) => {
            console.log('trigger qdp --', method);
            qdp[method]({
                keywords: params.name,
                count: params.count || 50,
                searchField: params.searchField,
                searchScope: params.searchScope,
                success: (res) => {
                    let list = [];
                    try {
                        list = res.data.list || [];
                    } catch (err) {
                        // no code
                    }
                    resolve(convertList(list, maps || {}));
                },
                fail: (err) => {
                    reject(err);
                },
            });
        });
    },
};
